import { ModuleRegistry, AllCommunityModule, themeBalham, themeQuartz } from "ag-grid-community";

ModuleRegistry.registerModules([AllCommunityModule]);

// Data grid: Airtable/Excel-inspired spreadsheet theme
export const spreadsheetTheme = themeBalham.withParams({
  spacing: 4,
  backgroundColor: '#ffffff',
  headerBackgroundColor: '#f8f8f8',
  headerTextColor: '#333333',
  headerFontWeight: 600,
  headerFontSize: 13,
  rowBorder: { width: 1, style: 'solid', color: '#e8e8e8' },
  columnBorder: { width: 1, style: 'solid', color: '#e8e8e8' },
  accentColor: '#3b82f6',
  selectedRowBackgroundColor: '#dbeafe',
  rowHoverColor: '#f5f5f5',
  rowHeight: 32,
  headerHeight: 36,
  cellTextColor: '#333333',
  fontSize: 13,
  cellFontSize: 13,
  wrapperBorder: { width: 1, style: 'solid', color: '#e0e0e0' },
  borderRadius: 6,
});

// Column definitions grid: preserve current Quartz look (no overrides)
export const columnDefsTheme = themeQuartz;
